import { render, staticRenderFns } from "./TableBlueLabelValue.vue?vue&type=template&id=39b0da85&scoped=true&"
import script from "./TableBlueLabelValue.vue?vue&type=script&lang=js&"
export * from "./TableBlueLabelValue.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueLabelValue.vue?vue&type=style&index=0&id=39b0da85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0da85",
  null
  
)

export default component.exports